import type { SxProps, Theme } from '@mui/material';
import type { CSSProperties } from 'react';

export const styles = {
    incomingEnvelopeImg: {
        fontSize: '64px',
        verticalAlign: 'middle',
        lineHeight: 1,
    } as CSSProperties,
    logoText: {
        marginTop: '24px',
        marginBottom: '24px',
        fontWeight: 400,
        fontSize: '32px',
    } as SxProps<Theme>,
    backButton: { color: '#808B90' } as CSSProperties,
    formStack: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        gap: '32px',
    } as SxProps<Theme>,
};
